var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile/header",
    transform: "translate(-325.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu/off"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#FFFFFF",
    x: 0,
    y: -1,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    transform: "translate(15.000000, 16.000000)",
    stroke: "#C3092F",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.5 L20,1.5",
    id: "Line",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.5 L20,8.5",
    id: "Line",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15.5 L20,15.5",
    id: "Line",
    strokeWidth: 3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.85f43e319a2a5031b76355028c77343f.svg";
export { ForwardRef as ReactComponent };